import { computed, inject, unref } from 'vue'
import { buildProp } from '@sgui-plus/utils/props'
import { componentSizes } from '@sgui-plus/utils/size'

import type { InjectionKey, Ref } from 'vue'
import type { ComponentSize } from '@sgui-plus/utils/size'

export const useSizeProp = buildProp({
  type: String,
  values: componentSizes,
  required: false,
} as const)

export const useSizeProps = {
  size: useSizeProp,
}

export interface SizeContext {
  size: Ref<ComponentSize>
}

export const SIZE_INJECTION_KEY: InjectionKey<SizeContext> = Symbol('size')

export const useGlobalSize = () => {
  const injectedSize = inject(SIZE_INJECTION_KEY, {} as SizeContext)

  return computed<ComponentSize>(() => {
    return unref(injectedSize.size) || ''
  })
}
